import { createAction } from '@reduxjs/toolkit';
export var getMopOnFile = createAction('MopOnFile/GET_MOP');
export var isLoadingMopOnFile = createAction('MopOnFile/IS_LOADING_MOP');
export var prependMopToList = createAction('MopOnFile/PREPEND_MOP');
export var updateMopList = createAction('MopOnFile/UPDATE_MOP_LIST');
export var setSelectedMop = createAction('MopOnFile/SET_SELECTED_MOP');
export var setEditableMop = createAction('MopOnFile/SET_EDIT_MOP');
export var setYifteeMop = createAction('MopOnFile/SET_YIFTEE_MOP');
export var getMopOnFileSuccess = createAction('MopOnFile/GET_MOP_SUCCESS');
export var getMopOnFileFailure = createAction('MopOnFile/GET_MOP_FAILURE');
export var yifteeInitialization = createAction('MopOnFile/YIFTEE_INITIALIZATION');
export var venmoInitialize = createAction('MopOnFile/VENMO_INITIALIZE');


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/redux/MopOnFileState/MopOnFileState.actions.js
// module id = 113
// module chunks = 11